import { JsonRpc, Ping } from '@/lib/web-api'
import { ClientFlowApi } from './ClientFlowApi'

import {
  API_TIMEOUT, commandUrl, pingUrl, getAuthTokenFn,
} from '../settings'

const pingFunction = (url = pingUrl) => Ping.ping(url)

// Set up the command sender that handles jsonrpc and network request
const cmdSender = new JsonRpc.Sender({
  url: commandUrl,
  timeOut: API_TIMEOUT,
  getAuthToken: getAuthTokenFn,
})

const api = new ClientFlowApi(cmdSender, pingFunction)
export default api
